import React from "react";
import { FiClock, FiLayers, FiArrowRight } from "react-icons/fi";
import { ResearcherProgram } from "../../utils/api/endpoints/checklists/researcherChecklistApi";

interface ResearcherAssignmentCardProps {
  program: ResearcherProgram;
  onClick: () => void;
}

export const ResearcherAssignmentCard: React.FC<ResearcherAssignmentCardProps> = ({
  program,
  onClick
}) => {
  const progress = program.total_items > 0 ? Math.round((program.completed_items / program.total_items) * 100) : 0;
  
  return (
    <div
      onClick={onClick}
      className="group bg-white rounded-xl border border-slate-200 p-5 cursor-pointer hover:border-slate-400 hover:shadow-xl hover:shadow-slate-200/50 transition-all duration-300 relative overflow-hidden"
    >
      {/* Company Badge */}
      <div className="flex items-center justify-between mb-4">
        <span className="text-[9px] font-black uppercase tracking-[0.15em] text-blue-600 bg-blue-50 px-2 py-0.5 rounded border border-blue-100/50">
          {program.company_name || 'System'}
        </span>
        <div className={`p-1.5 rounded-lg ${program.run_id ? 'bg-slate-50 text-slate-400' : 'bg-emerald-50 text-emerald-500'}`}>
          {program.run_id ? <FiClock className="w-3.5 h-3.5" /> : <FiLayers className="w-3.5 h-3.5" />}
        </div>
      </div>

      {/* Title & Run Info */}
      <div className="mb-6">
        <h3 className="text-sm font-bold text-slate-900 group-hover:text-blue-600 transition-colors line-clamp-1 mb-1">
          {program.program_title}
        </h3>
        {program.run_name ? (
          <div className="flex items-center gap-1.5">
            <span className="text-[10px] font-medium text-slate-500">Run:</span>
            <span className="text-[10px] font-bold text-slate-900">{program.run_name}</span>
          </div>
        ) : (
           <span className="text-[10px] font-bold text-emerald-600 uppercase tracking-wider">Product Master</span>
        )}
      </div>

      {/* Progress Section */}
      <div className="mt-auto">
        <div className="flex items-center justify-between mb-2">
          <span className="text-[10px] font-bold text-slate-400">
            {program.completed_items} / {program.total_items} VERIFIED
          </span>
          <span className="text-[10px] font-black text-slate-900">{progress}%</span>
        </div>
        <div className="w-full h-1.5 bg-slate-100 rounded-full overflow-hidden border border-slate-200/50">
          <div 
            className="h-full bg-slate-900 transition-all duration-700 ease-out"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>

      {/* Hover Action Indicator */}
      <div className="absolute right-4 bottom-14 opacity-0 group-hover:opacity-100 group-hover:translate-x-0 translate-x-2 transition-all duration-300">
        <FiArrowRight className="text-blue-600 w-4 h-4" />
      </div>
    </div>
  );
};
